import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AIMedia, UploadTypes } from '../../@types';

type Payload = {
  id: string;
  shouldFetchData?: boolean;
};

export const getAiMediaById = async (payload: Payload): Promise<AIMedia[]> => {
  const res = await axiosInstance.get(`/api/stock-gallery/get-ai-media/${payload.id}`);
  return res.data;
};

export const useGetAiMediaById = (payload: Payload) => {
  return useQuery(['getAllAiMediaData', payload], () => getAiMediaById(payload), {
    enabled: payload?.shouldFetchData,
    keepPreviousData: true,
  });
};
